<template>
  <div class="file_preview_modal" dir="rtl">
    <div v-if="is_loading" class="loading"></div>
    <p v-else-if="has_error" class="file_preview_error">שגיאה בטעינת הקובץ</p>
    <iframe v-else :src="pdf_src" width="100%" class="file_preview_iframe"></iframe>
  </div>
</template>
<script>
export default {
  name: 'file-preview-modal',
  props: {
    payload: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      is_loading: true,
      has_error: false,
      pdf_src: undefined,
      blob_file_url: undefined
    }
  },
  mounted () {
    this.loadFile()
  },
  beforeDestroy () {
    if (this.blob_file_url != undefined) {
      URL.revokeObjectURL(this.blob_file_url)
      this.blob_file_url = undefined
    }
  },
  methods: {
    loadFile () {
      this.$network_utils
        .getFile({
          file_name: this.payload.file_name,
          resource_id: this.payload.resource_id,
          resource_type: 'Applicant',
          show_archive: this.payload.is_archive
        })
        .then(response => {
          let blob_file = new Blob([response], { type: 'application/pdf' })
          this.blob_file_url = URL.createObjectURL(blob_file)
          this.pdf_src = this.blob_file_url + '#toolbar=0&navpanes=0&zoom=100'
          this.is_loading = false
        })
        .catch(error => {
          console.error('Error loading file preview:', error)
          this.has_error = true
          this.is_loading = false
        })
    }
  }
}
</script>
<style scoped>
.file_preview_modal {
  width: 100%;
  min-height: 200px;
}
.file_preview_iframe {
  display: block;
  height: 75vh;
  border: 0;
}
.file_preview_error {
  padding: 30px;
  color: #b30000;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
</style>
